/**
 * @generated SignedSource<<8b997e8a0dd3ceb5713f4c97b7c781ed>>
 * @relayHash 39f238d1445f1b61405caeca7fcdb48d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fd9644d1a7b659286bc77ccdbc604480ee1cf6d8e9cb56d237ed2d1ab0fdd675

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCapacityQuery } from './ui_jiraCapacityQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCapacityQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "fd9644d1a7b659286bc77ccdbc604480ee1cf6d8e9cb56d237ed2d1ab0fdd675",
    "metadata": {},
    "name": "ui_jiraCapacityQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
